import { render, staticRenderFns } from "./ordersService.vue?vue&type=template&id=287139c4&"
import script from "./ordersService.vue?vue&type=script&lang=js&"
export * from "./ordersService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports